function IconRenderer(data) {
    return function IconComponent(props) {
        const {
            size = 24,
            color = "white",
            stroke = color,
            className = "",
            style,
            ...restProps
        } = props;

        // Priorität der Farben: 1. color prop, 2. style prop, 3. default (white)
        const iconColor = color || style?.color || 'white';
        const iconStroke = stroke || style?.stroke || iconColor;

        const iconSizeW = size || style?.width || 24;
        const iconSizeH = size || style?.height || 24;

        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox={data.attr.viewBox}
                fill={iconColor} // Setzt die Farbe als fill
                width={iconSizeW}
                height={iconSizeH}
                color={iconColor} // Setzt die Farbe als color
                stroke={iconStroke} // Setzt die Farbe als stroke
                className={`ptr-icon ${className}`} // Füge die CSS-Klasse hinzu
                style={{ ...style }} // Inline-Style wird hier beibehalten
                {...restProps}
            >
                {data.child.map((child, index) => (
                    <child.tag 
                        key={index} 
                        {...child.attr}
                    >
                        {child.child ? child.child.map((grandChild, j) => (
                            <grandChild.tag key={j} {...grandChild.attr} />
                        )) : null}
                    </child.tag>
                ))}
            </svg>
        );
    };
}

const IconCopy = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "rect",
            attr: {
                x: 85,
                y: 295,
                width: 620,
                height: 620,
                rx: 85.86,
                ry: 85.86,
                fill: "none",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "path",
            attr: {
                d: "M294.5,171.36c0-47.42,38.44-85.86,85.86-85.86h448.29c47.42,0,85.86,38.44,85.86,85.86v448.29c0,47.42-38.44,85.86-85.86,85.86",
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80
            },
            child: []
        }
    ]
};

const IconClean = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "path",
            attr: {
                d: "M714,644.46v184.69c0,47.42-38.44,85.86-85.86,85.86H179.86c-47.42,0-85.86-38.44-85.86-85.86v-448.29c0-47.42,38.44-85.86,85.86-85.86h178.72",
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80
            },
            child: []
        },
        {
            tag: "g",
            attr: {},
            child: [
                {
                    tag: "rect",
                    attr: {
                        x: 631.55,
                        y: 10.21,
                        width: 164.91,
                        height: 551.58,
                        rx: 56.86,
                        ry: 56.86,
                        transform: "translate(411.36 -421.11) rotate(45)"
                    },
                    child: []
                },
                {
                    tag: "rect",
                    attr: {
                        x: 631.55,
                        y: 10.21,
                        width: 164.91,
                        height: 551.58,
                        rx: 56.86,
                        ry: 56.86,
                        transform: "translate(1421.11 -16.64) rotate(135)"
                    },
                    child: []
                }
            ]
        }
    ]
};

const IconPlus = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "circle",
            attr: {
                cx: 500,
                cy: 500,
                r: 406,
                fill: "none",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "path",
            attr: {
                d: "M500,295v410M295,500h410",
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80
            },
            child: []
        }
    ]
};

const IconMinus = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "circle",
            attr: {
                cx: 500,
                cy: 500,
                r: 406,
                fill: "none",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "path",
            attr: {
                d: "M295,500h410",
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80
            },
            child: []
        }
    ]
};

const IconInfo = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "circle",
            attr: {
                cx: 500,
                cy: 500,
                r: 406,
                fill: "none",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "line",
            attr: {
                x1: 500,
                y1: 700,
                x2: 500,
                y2: 480,
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "circle",
            attr: {
                cx: 500.5,
                cy: 287.5,
                r: 50,
            },
            child: []
        }
    ]
};

const IconPerson = {
    attr: { viewBox: "0 0 1000 1000" },
    child: [
        {
            tag: "path",
            attr: {
                d: "M94,906c0-224.23,181.77-406,406-406s406,181.77,406,406",
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        },
        {
            tag: "circle",
            attr: {
                cx: 498.5,
                cy: 244.5,
                r: 142.5,
                fill: "none",
                strokeLinecap: "round",
                strokeMiterlimit: 10,
                strokeWidth: 80,
            },
            child: []
        }
    ]
};

/* 

<svg id="Ebene1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
  <defs>
    <style>
      .cls-3 { stroke-miterlimit: 10; fill: none; stroke-linecap: round; stroke: #fff; stroke-width: 80px;}
    </style>
  </defs>
  <path class="cls-3" d="M94,906c0-224.23,181.77-406,406-406s406,181.77,406,406"/>
  <circle class="cls-3" cx="498.5" cy="244.5" r="142.5"/>
</svg>

*/

/* 
export function MdSettings(props) {
    return GenIcon({ 
        "tag": "svg", 
        "attr": { "viewBox": "0 0 24 24" }, 
        "child": [
        { 
            "tag": "path", 
            "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" }, 
            "child": [] 
        }, 
        { 
            "tag": "path", 
            "attr": { 
                "d": "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" 
            }, 
            "child": [] 
        }] 
    })(props);
}; */


const Logo = {
    attr: { viewBox: "0 0 240 36" },
    child: [
        {
            tag: "g",
            attr: {
                strokeWidth: 0.25,
                strokeMiterlimit: 10,
            },
            child: [
                {
                    tag: "path",
                    attr: {
                        d: "M51.1,28.1c-5.48,0-9.68-4.2-9.68-9.68v-2.71c0-5.48,4.2-9.68,9.68-9.68h8.64c1.25,0,2.29,1.04,2.29,2.29s-1.04,2.29-2.29,2.29h-8.53c-2.88,0-4.99,2.22-4.99,5.1v2.71c0,2.88,2.12,5.1,4.99,5.1h8.53c1.25,0,2.29,1.04,2.29,2.29s-1.04,2.29-2.29,2.29h-8.64Z",
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M72.84,28.1c-5.06,0-8.6-3.68-8.6-8.57v-1.25c0-4.89,3.54-8.57,8.6-8.57h3.4c5.06,0,8.6,3.68,8.6,8.57v1.25c0,4.89-3.54,8.57-8.6,8.57h-3.4ZM81.1,18.29c0-2.77-1.98-4.89-4.89-4.89h-3.33c-2.91,0-4.89,2.12-4.89,4.89v1.25c0,2.77,1.98,4.89,4.89,4.89h3.33c2.91,0,4.89-2.12,4.89-4.89v-1.25Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M88.07,3.69c0-.87.69-1.56,1.56-1.56s1.56.69,1.56,1.56v23.13c0,.87-.69,1.56-1.56,1.56s-1.56-.69-1.56-1.56V3.69Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M102.88,28.1c-5.06,0-8.6-3.68-8.6-8.57v-1.25c0-4.89,3.54-8.57,8.6-8.57h3.47c5.06,0,8.6,3.68,8.6,8.57v1.25c0,4.89-3.54,8.57-8.6,8.57h-3.47ZM112.45,18.29c0-3.5-2.53-6.14-6.17-6.14h-3.36c-3.64,0-6.14,2.64-6.14,6.14v1.25c0,3.5,2.5,6.14,6.14,6.14h3.36c3.64,0,6.17-2.64,6.17-6.14v-1.25Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M133.96,17.52c0,.52-.42.94-.94.94s-.94-.42-.94-.94v-1.63c0-2.5-1.84-4.37-4.4-4.37h-7.6v15.85c0,.52-.42.94-.94.94s-.94-.42-.94-.94V10.76c0-.59.42-1.04,1.04-1.04h8.43c3.61,0,6.28,2.67,6.28,6.17v1.63Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M137.46,28.1c-.31,0-.59-.28-.59-.59s.28-.59.59-.59h10.93c2.39,0,4.02-1.59,4.02-3.75s-1.63-3.68-4.02-3.68h-6.73c-3.09,0-5.27-2.08-5.27-4.86s2.19-4.92,5.27-4.92h10.93c.31,0,.59.28.59.59s-.28.59-.59.59h-10.93c-2.39,0-4.02,1.6-4.02,3.75s1.63,3.68,4.02,3.68h6.73c3.09,0,5.27,2.08,5.27,4.86s-2.19,4.92-5.27,4.92h-10.93Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M158.38,28.1v6.9c0,.35-.28.62-.62.62s-.62-.28-.62-.62V10.48c0-.45.31-.76.76-.76h9.16c5.06,0,8.6,3.68,8.6,8.57v1.25c0,4.89-3.54,8.57-8.6,8.57h-8.67ZM174.4,18.29c0-4.23-3.05-7.39-7.42-7.39h-8.6v16.02h8.6c4.37,0,7.42-3.16,7.42-7.39v-1.25Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M183.14,28.1c-3.09,0-5.27-2.57-5.27-5.27s2.19-5.24,5.27-5.24h8.29c.31,0,.59.28.59.59s-.28.59-.59.59h-8.29c-2.39,0-4.02,1.98-4.02,4.06s1.63,4.09,4.02,4.09h11.65v-10.89c0-3.16-1.91-5.13-5.06-5.13h-9.26c-.31,0-.59-.28-.59-.59s.28-.59.59-.59h9.26c3.85,0,6.31,2.46,6.31,6.31v11.31c0,.45-.31.76-.76.76h-12.14Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M207.98,28.1c-5.06,0-8.6-3.68-8.6-8.57v-1.25c0-4.89,3.54-8.57,8.6-8.57h8.01c.31,0,.59.28.59.59s-.28.59-.59.59h-7.94c-4.37,0-7.42,3.16-7.42,7.39v1.25c0,4.23,3.05,7.39,7.42,7.39h7.94c.31,0,.59.28.59.59s-.28.59-.59.59h-8.01Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M226.71,28.1c-5.06,0-8.6-3.68-8.6-8.57v-1.25c0-4.89,3.54-8.57,8.6-8.57h5.93c3.26,0,5.45,2.29,5.45,5.03s-2.19,5-5.45,5h-9.16c-.31,0-.59-.28-.59-.59s.28-.59.59-.59h9.16c2.57,0,4.2-1.7,4.2-3.82s-1.63-3.85-4.2-3.85h-5.86c-4.37,0-7.42,3.16-7.42,7.39v1.25c0,4.23,3.05,7.39,7.42,7.39h8.98c.31,0,.59.28.59.59s-.28.59-.59.59h-9.05Z"
                    },
                    child: []
                },
                {
                    tag: "path",
                    attr: {
                        d: "M32.22,22.43c-.24-2.09-1.6-3.77-3.41-4.54.04-.67.03-1.34-.05-2.01-.06-.49-.16-.97-.28-1.43,2.34-.91,3.88-3.31,3.57-5.91-.17-1.5-.92-2.84-2.1-3.77-1.18-.93-2.65-1.36-4.16-1.18-1.5.17-2.84.92-3.77,2.11-.26.33-.47.68-.65,1.05-1.33-.46-2.77-.66-4.25-.57-1.31-1.9-3.61-3.04-6.05-2.75-3.53.41-6.06,3.62-5.65,7.15.17,1.42.78,2.7,1.76,3.71-.32,1.19-.46,2.45-.36,3.74-1.34.46-2.52,1.29-3.42,2.43-1.24,1.58-1.8,3.54-1.57,5.53s1.23,3.78,2.8,5.02c1.34,1.06,2.96,1.62,4.65,1.62.29,0,.59-.02.89-.05,1.99-.23,3.78-1.23,5.02-2.8.42-.53.75-1.11,1.01-1.71.52.08,1.05.13,1.6.13.43,0,.85-.02,1.29-.08h0c1.26-.15,2.45-.51,3.56-1.05.15.15.3.32.47.45,1.01.8,2.23,1.22,3.49,1.22.22,0,.44-.01.67-.04,3.09-.36,5.31-3.17,4.95-6.26ZM22.11,8.32c.08-.39.19-.78.37-1.14.13-.26.29-.52.48-.76.74-.93,1.79-1.52,2.97-1.66.17-.02.35-.03.52-.03,2.22,0,4.15,1.67,4.41,3.93.24,2.03-.94,3.88-2.74,4.61-.36.15-.74.27-1.15.32,0,0,0,0,0,0-2.43.28-4.64-1.47-4.93-3.9-.05-.47-.02-.93.07-1.38ZM6.62,10.43c-.34-2.87,1.73-5.48,4.6-5.82.21-.02.41-.04.61-.04,1.53,0,2.92.68,3.89,1.76-3.73.72-6.7,3.27-8.09,6.6-.54-.73-.91-1.58-1.02-2.51ZM15.41,26.68c-.1.39-.24.77-.41,1.14-.2.43-.45.83-.75,1.21-1.05,1.32-2.54,2.16-4.22,2.35-1.68.2-3.33-.27-4.65-1.32s-2.16-2.54-2.35-4.22c-.2-1.68.27-3.33,1.32-4.65.7-.89,1.61-1.55,2.64-1.95.37-.15.76-.26,1.16-.33.14-.03.28-.05.42-.07.25-.03.49-.04.74-.04,3.16,0,5.89,2.37,6.27,5.58.09.78.03,1.56-.16,2.3ZM18.95,26.92c-.8.09-1.59.08-2.36-.02.21-.86.28-1.76.17-2.66-.48-4.12-4.22-7.08-8.33-6.59-.14.02-.28.05-.42.07-.05-.89.03-1.76.2-2.6.09-.42.2-.82.34-1.22,1.19-3.38,4.18-5.97,7.94-6.48.06,0,.12-.02.18-.03.37-.04.74-.06,1.1-.06.02,0,.03,0,.05,0,1.1,0,2.17.19,3.17.54-.15.64-.21,1.3-.13,1.98.33,2.87,2.78,4.99,5.6,4.99.22,0,.44-.01.66-.04.08,0,.15-.03.22-.04.1.41.19.83.24,1.26.06.51.07,1.02.05,1.52-.01.41-.05.81-.11,1.21-.26,1.63-.93,3.18-1.99,4.51-.73.92-1.61,1.69-2.59,2.28.05.07.11.14.16.21h0c-.05-.07-.11-.13-.16-.21-.34.21-.69.4-1.06.57-.92.41-1.9.69-2.92.81ZM27.13,27.5c-1.17.14-2.34-.19-3.27-.93-.05-.04-.08-.08-.13-.12-.13-.11-.14-.12,0,0,1.02-.65,1.95-1.47,2.73-2.45,1.13-1.43,1.88-3.09,2.2-4.84,1.26.66,2.2,1.89,2.37,3.41.28,2.43-1.46,4.65-3.9,4.93Z"
                    },
                    child: []
                }
            ]
        }
    ]
};

const LogoBalls = {
    attr: { viewBox: "0 0 28.35 28.35" },
    child: [

/*         {
            tag: "path",
            attr: {
                d: "M6.6,9.62c-.17-.52-.26-1.08-.26-1.65,0-2.96,2.4-5.35,5.35-5.35,1.77,0,3.34.87,4.32,2.2-.36-.04-.71-.07-1.08-.07-3.57,0-6.69,1.97-8.32,4.87ZM24.23,16.44c-.71,3.08-2.89,5.58-5.77,6.73.83,1.25,2.24,2.08,3.85,2.08,2.55,0,4.62-2.07,4.62-4.62,0-1.86-1.11-3.46-2.7-4.19ZM24.23,16.44c.16-.69.25-1.4.25-2.14,0-1.06-.18-2.07-.5-3.02-.52.2-1.08.32-1.67.32-2.55,0-4.62-2.07-4.62-4.62,0-.61.12-1.18.34-1.71-.65-.22-1.32-.38-2.02-.46-.36-.04-.71-.07-1.08-.07-3.57,0-6.69,1.97-8.32,4.87-.7,1.24-1.11,2.65-1.19,4.15.72-.29,1.51-.45,2.34-.45,3.5,0,6.33,2.84,6.33,6.33,0,1.49-.52,2.85-1.37,3.93.71.17,1.45.27,2.22.27,1.25,0,2.44-.25,3.53-.68,2.88-1.15,5.07-3.65,5.77-6.73ZM22.31,11.6c.59,0,1.15-.12,1.67-.32,1.72-.67,2.95-2.34,2.95-4.3,0-2.55-2.07-4.62-4.62-4.62-1.95,0-3.6,1.21-4.28,2.91-.21.53-.34,1.11-.34,1.71,0,2.55,2.07,4.62,4.62,4.62ZM7.75,13.32c-.83,0-1.62.16-2.34.45-2.34.93-3.99,3.21-3.99,5.88,0,3.5,2.84,6.33,6.33,6.33,2.01,0,3.8-.94,4.96-2.4.86-1.08,1.37-2.44,1.37-3.93,0-3.5-2.84-6.33-6.33-6.33Z",
                fill: '#fff',
                stroke: 'none'
            },
            child: []
        }, */
        {
            tag: "path",
            attr: {
                d: "M7.75,26.73c-3.91,0-7.08-3.18-7.08-7.08,0-2.76,1.57-5.21,4.03-6.39.13-1.33.5-2.58,1.1-3.73-.14-.52-.21-1.04-.21-1.57,0-3.37,2.74-6.1,6.1-6.1,1.82,0,3.56.83,4.72,2.24.4.06.81.15,1.22.26.94-1.69,2.71-2.75,4.68-2.75,2.96,0,5.37,2.41,5.37,5.37,0,1.99-1.08,3.77-2.79,4.7.23.86.34,1.74.34,2.61,0,.57-.05,1.15-.15,1.74,1.6.96,2.6,2.71,2.6,4.59,0,2.96-2.41,5.37-5.37,5.37-1.61,0-3.11-.71-4.12-1.93-1.66.56-3.4.69-5.2.34-1.34,1.48-3.23,2.32-5.24,2.32ZM5.69,14.47c-2.14.85-3.52,2.89-3.52,5.18,0,3.08,2.5,5.58,5.58,5.58,1.71,0,3.3-.77,4.37-2.12.76-.96,1.18-2.1,1.21-3.31,0-.03,0-.05,0-.07,0-.03,0-.05,0-.08,0-3.08-2.5-5.58-5.58-5.58-.7,0-1.4.13-2.06.4ZM19.66,23.44c.71.67,1.65,1.06,2.65,1.06,2.13,0,3.87-1.74,3.87-3.87,0-1.2-.57-2.32-1.5-3.04-.85,2.53-2.65,4.63-5.03,5.86ZM13.96,23.04c1.47.17,2.87-.04,4.21-.57,0,0,.01,0,.02,0,2.53-1.01,4.44-3.13,5.18-5.73.04-.15.08-.31.12-.47h0c.15-.67.23-1.33.23-1.97,0-.69-.09-1.39-.25-2.08-.36.08-.72.13-1.08.13-2.99.05-5.46-2.38-5.46-5.37,0-.41.05-.81.14-1.21-.39-.1-.78-.17-1.16-.22-.3-.03-.6-.06-.9-.06-.03,0-.06,0-.09,0-3.17,0-6.11,1.72-7.67,4.49-.48.85-.8,1.76-.97,2.74.43-.09.87-.14,1.31-.15.05,0,.11,0,.16,0,3.91,0,7.08,3.18,7.08,7.08,0,1.21-.3,2.36-.87,3.39ZM18.44,6.98c0,2.13,1.74,3.87,3.87,3.87.46,0,.94-.09,1.4-.27,1.5-.58,2.47-2,2.47-3.6,0-2.13-1.74-3.87-3.87-3.87-1.58,0-2.99.95-3.58,2.42h0s0,.02,0,.03c-.18.44-.27.9-.28,1.36v.06ZM11.69,3.36c-2.42,0-4.4,1.87-4.59,4.24,1.76-2.05,4.26-3.35,6.97-3.57-.71-.43-1.53-.67-2.39-.67Z",
                stroke: 'none'
            },
            child: []
        }
    ]
};

/* <?xml version="1.0" encoding="UTF-8"?>
<svg id="a" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 28.35 28.35">
    <defs>
        <style>.c{fill:url(#b);}.d{fill:#6aeae6;}</style>
        <linearGradient id="b" x1=".67" y1="14.17" x2="27.68" y2="14.17"
            gradientUnits="userSpaceOnUse">
            <stop offset=".05" stop-color="#9b00ff" />
            <stop offset=".5" stop-color="#ff009b" />
            <stop offset=".95" stop-color="red" />
        </linearGradient>
    </defs>
    <path class="d"
        d="M6.6,9.62c-.17-.52-.26-1.08-.26-1.65,0-2.96,2.4-5.35,5.35-5.35,1.77,0,3.34.87,4.32,2.2-.36-.04-.71-.07-1.08-.07-3.57,0-6.69,1.97-8.32,4.87ZM24.23,16.44c-.71,3.08-2.89,5.58-5.77,6.73.83,1.25,2.24,2.08,3.85,2.08,2.55,0,4.62-2.07,4.62-4.62,0-1.86-1.11-3.46-2.7-4.19ZM24.23,16.44c.16-.69.25-1.4.25-2.14,0-1.06-.18-2.07-.5-3.02-.52.2-1.08.32-1.67.32-2.55,0-4.62-2.07-4.62-4.62,0-.61.12-1.18.34-1.71-.65-.22-1.32-.38-2.02-.46-.36-.04-.71-.07-1.08-.07-3.57,0-6.69,1.97-8.32,4.87-.7,1.24-1.11,2.65-1.19,4.15.72-.29,1.51-.45,2.34-.45,3.5,0,6.33,2.84,6.33,6.33,0,1.49-.52,2.85-1.37,3.93.71.17,1.45.27,2.22.27,1.25,0,2.44-.25,3.53-.68,2.88-1.15,5.07-3.65,5.77-6.73ZM22.31,11.6c.59,0,1.15-.12,1.67-.32,1.72-.67,2.95-2.34,2.95-4.3,0-2.55-2.07-4.62-4.62-4.62-1.95,0-3.6,1.21-4.28,2.91-.21.53-.34,1.11-.34,1.71,0,2.55,2.07,4.62,4.62,4.62ZM7.75,13.32c-.83,0-1.62.16-2.34.45-2.34.93-3.99,3.21-3.99,5.88,0,3.5,2.84,6.33,6.33,6.33,2.01,0,3.8-.94,4.96-2.4.86-1.08,1.37-2.44,1.37-3.93,0-3.5-2.84-6.33-6.33-6.33Z" />
    <path class="c"
        d="M7.75,26.73c-3.91,0-7.08-3.18-7.08-7.08,0-2.76,1.57-5.21,4.03-6.39.13-1.33.5-2.58,1.1-3.73-.14-.52-.21-1.04-.21-1.57,0-3.37,2.74-6.1,6.1-6.1,1.82,0,3.56.83,4.72,2.24.4.06.81.15,1.22.26.94-1.69,2.71-2.75,4.68-2.75,2.96,0,5.37,2.41,5.37,5.37,0,1.99-1.08,3.77-2.79,4.7.23.86.34,1.74.34,2.61,0,.57-.05,1.15-.15,1.74,1.6.96,2.6,2.71,2.6,4.59,0,2.96-2.41,5.37-5.37,5.37-1.61,0-3.11-.71-4.12-1.93-1.66.56-3.4.69-5.2.34-1.34,1.48-3.23,2.32-5.24,2.32ZM5.69,14.47c-2.14.85-3.52,2.89-3.52,5.18,0,3.08,2.5,5.58,5.58,5.58,1.71,0,3.3-.77,4.37-2.12.76-.96,1.18-2.1,1.21-3.31,0-.03,0-.05,0-.07,0-.03,0-.05,0-.08,0-3.08-2.5-5.58-5.58-5.58-.7,0-1.4.13-2.06.4ZM19.66,23.44c.71.67,1.65,1.06,2.65,1.06,2.13,0,3.87-1.74,3.87-3.87,0-1.2-.57-2.32-1.5-3.04-.85,2.53-2.65,4.63-5.03,5.86ZM13.96,23.04c1.47.17,2.87-.04,4.21-.57,0,0,.01,0,.02,0,2.53-1.01,4.44-3.13,5.18-5.73.04-.15.08-.31.12-.47h0c.15-.67.23-1.33.23-1.97,0-.69-.09-1.39-.25-2.08-.36.08-.72.13-1.08.13-2.99.05-5.46-2.38-5.46-5.37,0-.41.05-.81.14-1.21-.39-.1-.78-.17-1.16-.22-.3-.03-.6-.06-.9-.06-.03,0-.06,0-.09,0-3.17,0-6.11,1.72-7.67,4.49-.48.85-.8,1.76-.97,2.74.43-.09.87-.14,1.31-.15.05,0,.11,0,.16,0,3.91,0,7.08,3.18,7.08,7.08,0,1.21-.3,2.36-.87,3.39ZM18.44,6.98c0,2.13,1.74,3.87,3.87,3.87.46,0,.94-.09,1.4-.27,1.5-.58,2.47-2,2.47-3.6,0-2.13-1.74-3.87-3.87-3.87-1.58,0-2.99.95-3.58,2.42h0s0,.02,0,.03c-.18.44-.27.9-.28,1.36v.06ZM11.69,3.36c-2.42,0-4.4,1.87-4.59,4.24,1.76-2.05,4.26-3.35,6.97-3.57-.71-.43-1.53-.67-2.39-.67Z" />
</svg> */



const JiCopy = IconRenderer(IconCopy);
const JiClean = IconRenderer(IconClean);
const JiPlus = IconRenderer(IconPlus);
const JiMinus = IconRenderer(IconMinus);
const JiInfo = IconRenderer(IconInfo);
const JiPerson = IconRenderer(IconPerson);

const JiLogo = IconRenderer(Logo);
const JiLogoBalls = IconRenderer(LogoBalls);

export {
    JiCopy,
    JiClean,
    JiInfo,
    JiPlus,
    JiMinus,
    JiPerson,
    JiLogo,
    JiLogoBalls
}
